import {Component, Vue} from 'vue-facing-decorator';
import SideBarMenu from '@/components/SideBarMenu/SideBarMenu.vue';
import HeaderMenu from '@/components/HeaderMenu/HeaderMenu.vue';
import Footer from '@/components/Footer/Footer.vue';
import BottomMenu from '@/components/BottomMenu/BottomMenu.vue';
//import { ref } from 'vue';


@Component({
    components: {
        'MenuBar' : HeaderMenu,
        'app-footer' : Footer,
        'app-sidebar-menu' : SideBarMenu,
        'app-bottom-menu' : BottomMenu,
    }
})
export default class Main extends Vue {
    isMobile = window.innerWidth <= 768;

    get app_base_data(): any {
        return this.$store.state.baseData;
    }

    get getMenus() {
        const path = this.$router.currentRoute.value.path;
        const user = this.$store.getters['user/getUser'];
        const group= user.header.length ?  user.header.filter((menu: any) => menu.to === path) : [];
        if(group.length){
            return user.header.filter((menu: any) => menu.header === group[0].header)
        }
        return [];
    }

    get containerClass(){
          return {
            'layout-overlay': this.$store.getters['ui/layoutSidebarMode'] === 'overlay',
            'layout-static' : this.$store.getters['ui/layoutSidebarMode'] === 'static',
            'layout-static-inactive': this.$store.getters['ui/staticMenuDesktopInactive'] && this.$store.getters['ui/layoutSidebarMode'] === 'static',
            'layout-overlay-active': this.$store.getters['ui/overlayMenuActive'],
            'layout-mobile-active': this.$store.getters['ui/staticMenuMobileActive'],
          };
    }

    
    

    isOutsideClicked(event : any){
        const sidebarEl = document.querySelector('.layout-sidebar');
        const topbarEl = document.querySelector('.layout-menu-button');
        const c = !(sidebarEl?.isSameNode(event.target) || sidebarEl?.contains(event.target) || topbarEl?.isSameNode(event.target) || topbarEl?.contains(event.target));
        if (c) {
            if(this.$store.getters['ui/isSidebarActive']){
                this.$store.dispatch('ui/toggleMenuSidebar'); 
            }
        }
    }

    handleResize() {
        this.isMobile = window.innerWidth <= 768;
    }

    created() {
        window.addEventListener('resize', this.handleResize);
    }
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    }
    mounted() {
        document.addEventListener('click', this.isOutsideClicked);

        const user = this.$store.getters['user/getUser'];
        this.item_side_menu = user.menus;
    }

    beforeUnmount() {
        document.removeEventListener('click', this.isOutsideClicked);
    }
    //========================================================================================


    //========================================================================================
    item_side_menu = [];
}   